import React, { useContext, useState } from "react";
import { InputType, } from "../../Utils/Utils";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import { AuthContext } from "../../Context/authContext";
import { SvgImages } from "../../Utils/LocalImages";
import ApiConstants from "../../Utils/ApiConstant";
import Image from "../../Components/Reusable/Image";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import Profilemodal from "../../Components/Modal/Profilemodal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";


const StudentProfile = ({ show }) => {
  const { user } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const handleProfileClick = () => {
    setShowModal(true);
  };
  const removeTimeFromDate = (dateString) => {
    if (!dateString) return '';
    const dateObject = new Date(dateString);
    // Ensure the date is parsed as UTC
    const utcYear = dateObject.getUTCFullYear();
    const utcMonth = dateObject.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
    const utcDay = dateObject.getUTCDate();
    return `${utcDay} ${utcMonth} , ${utcYear}`;

  };

  const { register: registerDetails, handleSubmit: handleSubmitDetails, setValue: setUserValues, formState: { errors: errorsDetails } } = useForm({
    defaultValues: {
      firstName: user?.firstName || '',
      middleName: user?.middleName || '',
      lastName: user?.lastName || '',
      dateOfBirth: removeTimeFromDate(user?.dateOfBirth) || '',
      mobile: user?.mobile || '',
      dob: user?.dob || '',
      gender: user?.gender || '',
      schoolName: user?.schoolName || '',
      medium: user?.medium || '',
      class: user?.class_name || '',
      registerBy: user?.registerBy || '',
      referralCode: user?.referralCode || '',
      email: user?.email || '',
      address1: user?.addressLineOne || '',
      address2: user?.addressLineTwo || '',
      state: user?.state || '',
      district: user?.district || '',
      taluka: user?.taluka || '',
      pinCode: user?.pinCode || '',
    },
  });

  return (
    <div className="d-flex">
      < Sidebar />
      <div className="mainLayout-content">
        <StudentNavbar />
        <div className="main_content contentSection scroll_bar">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black sub-large-text-one fw-700 mb-0">Profile Details</h1>
          </div>
          <form >
            <div className=" d-flex flex-column p-0">

              <div className="d-flex flex-column justify-content-center mt-4">
                <div className=" d-flex justify-content-center select_profile_img student-profile">
                  {/* <CustomTextFieldTwo id="file" type="file" className="d-none" /> */}
                  <Image className="modal_profile" style={{ objectFit: "cover" }} src={user?.profilePicture && user.profilePicture?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + user.profilePicture : SvgImages.user_profile} onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = SvgImages.user_profile;
                  }} />

                  <div className="position-relative"onClick={handleProfileClick}>
                    <a className="secondary fs-16 fw-500 edit_img d-flex justify-content-center align-items-center cursor-pointer" >
                      <Image src={SvgImages.profile_editng}  style={{ height: 19, width: 19 }} />
                    </a>

                    {/* <input type="file" className="edit_img opacity-0" multiple={false} accept="image/*" name="fileupload"
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      updateProfilePic(e.target.files[0]);
                    }
                  }} /> */}
                  </div>
                  <Profilemodal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    title={"Update Profile Picture"}
                    titletwo={"Delete Photo"}
                    submitButtonText={"Update Photo"}
                    className="Updatebtnmodal"
                  >
                  </Profilemodal>
                </div>

              </div>

              <div className="pb-3 mt-5 d-flex justify-content-between  align-items-center">
                <h1 className="blue sub-large-text-one  fw-600 mb-0">Personal Details</h1>
              </div>
              <div className="hrline2" style={{ marginRight: '30px' }}></div>
              <div className="row profile_inputs mt-3 w-100">
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="First Name"
                    placeholder="First Name"
                    defaultValue={user?.firstName || ''} 
                    {...registerDetails("firstName")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"
                  />
                </div>

                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Middle Name"
                    placeholder="Middle Name"
                    defaultValue={user?.middleName || ''} 
                    {...registerDetails("middleName")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"
                  />
                </div>

                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Last Name"
                    placeholder="Last Name"
                    defaultValue={user?.lastName || ''} 
                    {...registerDetails("lastName")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>

                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Date Of Birth"
                    placeholder="Date Of Birth"
                    defaultValue={removeTimeFromDate(user?.dateOfBirth) || ''} 
                    {...registerDetails("dateOfBirth")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Gender"
                    placeholder="Gender"
                    defaultValue={user?.gender || ''} 
                    {...registerDetails("gender")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="School Name"
                    placeholder="School Name"
                    defaultValue={user?.schoolName || ''} 
                    {...registerDetails("schoolName")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Medium"
                    placeholder="Medium"
                    defaultValue={user?.medium || ''} 
                    {...registerDetails("medium")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Class"
                    placeholder="Class"
                    defaultValue={user?.class_name || ''} 
                    {...registerDetails("class_name")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Register By"
                    placeholder="Register By"
                    defaultValue={user?.registerBy || ''} 
                    {...registerDetails("registerBy")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>
                {user?.registerBy === "Coordinator" && (
                  <div className="col-md-6">
                    <CustomTextFieldTwo
                      labelTitle="Unique Code"
                      placeholder="Unique Code"
                      defaultValue={user?.referralCode || ''}
                      {...registerDetails("referralCode")}
                      disabled={true}
                      additionalClasses="coprofile_edit"
                      labelClass="fw-600"
                    />
                  </div>
                )}
              </div>
              <div className="pb-3 mt-5 d-flex justify-content-between  align-items-center">
                <h1 className="blue sub-large-text-one fw-600 mb-0">Contact Details</h1>

              </div>
              <div className="hrline2" style={{ marginRight: '30px' }}></div>
              <div className="row profile_inputs mt-3 w-100">
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Email"
                    placeholder="Email"
                    defaultValue={user?.email || ''} 
                    {...registerDetails("email")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>

                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Mobile"
                    placeholder="Mobile"
                    defaultValue={user?.mobile || ''} 
                    {...registerDetails("mobile")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>

                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Address Line-1"
                    placeholder="Address Line-1"
                    defaultValue={user?.addressLineOne || ''} 
                    {...registerDetails("addressLineOne")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>

                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Address Line-2"
                    placeholder="09/05/1992"
                    defaultValue={user?.addressLineTwo || ''} 
                    {...registerDetails("addressLineTwo")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"


                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="State"
                    placeholder="State"
                    defaultValue={user?.state || ''} 
                    {...registerDetails("state")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"

                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="District"
                    placeholder="District"
                    defaultValue={user?.district || ''} 
                    {...registerDetails("district")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Taluka"
                    placeholder="Taluka"
                    defaultValue={user?.taluka || ''} 
                    {...registerDetails("taluka")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"
                  />
                </div>
                <div className="col-md-6">
                  <CustomTextFieldTwo
                    labelTitle="Pincode"
                    placeholder="Pincode"
                    defaultValue={user?.pinCode || ''} 
                    {...registerDetails("pinCode")}
                    disabled={true}
                    additionalClasses="coprofile_edit"
                    labelClass="fw-600"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StudentProfile;

